import React, { useEffect, useState } from 'react';
import { Network, ChevronDown, ChevronUp, X } from 'lucide-react';
import { MandantAktePicker } from './MandantAktePicker';
import { useMandantAusUrl } from '../kanzlei/NeuMenu';
import { api } from '../../context/AuthContext';

const gefuellt = (o = {}) => Object.fromEntries(Object.entries(o || {}).filter(([, x]) => x !== '' && x != null));

// Nur Kanzlei-Formulare: Mandant → Akte aus dem Register wählen und Formular mit allen bekannten Daten vorausfüllen
export const RegisterPrefill = ({ onPick, testId = 'register-prefill', startOffen = false }) => {
  const [open, setOpen] = useState(startOffen);
  const [sel, setSel] = useState(null);
  const [uebernommen, setUebernommen] = useState(0);
  const change = async (v) => {
    setSel(v); setUebernommen(0);
    if (!v?.mandanten_nr) { onPick(v); return; }
    let vb = {};
    try { vb = (await api.get(`/register/mandanten/${v.mandanten_nr}/vorbelegung`)).data || {}; } catch { vb = {}; }
    const { mandanten_nr: _n, name, email, ...rest } = vb;
    const akte = { ...gefuellt(rest), ...gefuellt(v.akte) };
    setUebernommen(Object.keys(akte).length);
    onPick({ ...v, name: v.name || name, email: v.email || email, akte });
  };
  const clear = () => { setSel(null); onPick(null); };
  const ausUrl = useMandantAusUrl();
  useEffect(() => { if (ausUrl) change({ mandanten_nr: ausUrl.mandanten_nr, case_id: null, name: ausUrl.name, email: ausUrl.email, akte: null }); }, [ausUrl]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="border border-dashed border-[#1B3A5C]/25 bg-[#f5f8fa]/60 rounded-sm" data-testid={testId}>
      <div className="flex items-center gap-2 px-3 py-2">
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${testId}-toggle`} className="inline-flex items-center gap-2 text-[11px] tracking-[0.15em] uppercase text-[#1B3A5C] hover:text-[#b8893d]">
          <Network className="w-3.5 h-3.5 text-[#b8893d]" /> Mandant → Akte zuordnen {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
        </button>
        {sel?.mandanten_nr && (
          <span className="ml-auto inline-flex items-center gap-1.5 text-[10px] font-mono px-2 py-0.5 rounded-full bg-[#1B3A5C] text-white" data-testid={`${testId}-selected`}>
            M-{sel.mandanten_nr}{sel.akte?.aktenzeichen ? ` · AZ ${sel.akte.aktenzeichen}` : ''}
            <button type="button" onClick={clear} aria-label="Zuordnung entfernen" data-testid={`${testId}-clear`}><X className="w-3 h-3" /></button>
          </span>
        )}
      </div>
      {uebernommen > 0 && <p className="px-3 pb-2 -mt-1 text-[11px] text-emerald-700" data-testid={`${testId}-uebernommen`}>{uebernommen} bekannte Angaben übernommen – neue Angaben werden beim Speichern beim Mandanten ergänzt.</p>}
      {open && <div className="px-3 pb-3"><MandantAktePicker value={sel} onChange={change} testId={`${testId}-picker`} /><p className="mt-2 text-[10px] text-[#7a8a99]">Name, E-Mail, Telefon und Aktenzeichen werden übernommen und können danach angepasst werden.</p></div>}
    </div>
  );
};

export const splitName = (sel) => {
  const a = sel?.akte;
  if (a?.firstName || a?.lastName) return { vorname: a.firstName || '', nachname: a.lastName || '' };
  const parts = (sel?.name || '').trim().split(/\s+/);
  return { vorname: parts.slice(0, -1).join(' '), nachname: parts.slice(-1)[0] || '' };
};

export default RegisterPrefill;
